import { useRef, useState } from "react";
import  { AttributeCollection, setNodeComponentAttributeValue, setNodeStyleAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { AttributeFieldProps } from "./RenderAttributeInput";
import GearIcon from "../Icons/GearIcon";
import { GetComponentOrStyleValueFromDefinition } from "../Data/WBData";

import { attributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";

import ColorInputField from "./ColorInputField";






const NumInput = ({ label,defaultVal,onUpdate,fullWidth }: { label: string,defaultVal:number,onUpdate:Function,fullWidth?:boolean }) => {
    return (
      <>
        <div style={{ width: (fullWidth?"100%":"50%"),padding:"4px" }}>
          <label>{label}</label>
          <div className="sizing-input-group"> 
          <input defaultValue={defaultVal} type="number" className="w-full" 
          onInput={(e)=>{
              let val = parseFloat((e.target as any).value);
              if(isNaN(val))
                  val = 0;
              onUpdate(val);

          }}
          
          ></input>
          <div className="unit" style={{cursor:"default"}}>px</div>
          </div>
        </div>

      </>
    );
  };

export default function ShadowField(props:AttributeFieldProps){

    const includeSpread = props.definition.attribute == attributeTypes.textShadow?false:true;
 
    const currentShadow = GetComponentOrStyleValueFromDefinition(props.definition,props.layoutObject,props.screenSize,"");// getNodeStyleAttributeValue(props.layoutObject,ScreenSize.Desktop,props.definition.attribute,"");
    
    const options = props.definition.options;

    let foundIndex = -1;
    for(let i =0;i<options.length;i++){
        if(options[i].value == currentShadow){
            foundIndex = i;
            break;
        }

    }
    
    
    const [updateToggle,setUpdatetoggle] = useState(false);


    const[selectedIndex,setSelectedIndex] = useState(foundIndex);
    const parseShadow = (shadow:string)=>{

        const result = {
            x:0,
            y:0,
            blur:0,
            spread:0,
            color:""
        }

        let split = shadow.trim().split(" ");

        if(includeSpread){
          if(split.length>4){
              result.x  = parseFloat(split[0]);
              result.y  = parseFloat(split[1]);
              result.blur  = parseFloat(split[2]);
              result.spread  = parseFloat(split[3]);
              result.color  = split[4];


          }
        }
        else{
          if(split.length>3){
            result.x  = parseFloat(split[0]);
            result.y  = parseFloat(split[1]);
            result.blur  = parseFloat(split[2]);
            result.color  = split[3];
            result.spread = 0;


          }
        }
       


        return result;


    }

    const parsed = parseShadow(currentShadow);
    const x = useRef(parsed.x);
    const y = useRef(parsed.y);
    const blur = useRef(parsed.blur);
    const spread = useRef(parsed.spread);
    const color = useRef(parsed.color);

    // let isCustom = true;

    // for(let i =0;i<props.definition.options.length;i++){

    //     if(props.definition.options[i].value == currentShadow)
    //         isCustom = false;
    // }


    const updateColor = (att:string,val:string) =>{
        color.current = val;
        updateCustom();
    }

    const onButtonUpdate = (att:string,value:string)=>{

        props.updateFunc(att,value,props.definition.targetType);
        let parsed = parseShadow(value);
        x.current = parsed.x;
        y.current = parsed.y;
        blur.current = parsed.blur;
        spread.current = parsed.spread;
        color.current = parsed.color;
        setUpdatetoggle(!updateToggle);
        props.saveFunc();

    }

    const collerCollectoin = new AttributeCollection();
    setNodeStyleAttributeValue(collerCollectoin,ScreenSize.Desktop,props.definition.attribute,color.current);
    setNodeComponentAttributeValue(collerCollectoin,props.definition.attribute,color.current);
    const updateCustom = ()=>{

        let shadow = (includeSpread)?`${x.current}px ${y.current}px ${blur.current}px ${spread.current}px ${color.current}`:`${x.current}px ${y.current}px ${blur.current}px ${color.current}`;
        props.updateFunc(props.definition.attribute,shadow,props.definition.targetType);
    }

   return <><div className="wb-input-group" style={{padding:"0px"}}> 

<div className={"wb-input-group "+props.definition.attKey.toLowerCase() }>
{props.definition.label &&
        <label className={(currentShadow=="")?"not-updated":"updated"}>{props.label}</label>
      }
        <div className="wb-input-row">
          {options.map((option, index) => {
            let className = index==foundIndex ? "selected" : "";
    
            return (
              <button
              
                className={className}
                key={index}
                style={(option.label=="Auto"||(option.label as string).length>2)?{fontSize:"13px"}:{}}
                onClick={() => {
                setSelectedIndex(index);
                onButtonUpdate(props.definition.attribute, option.value);
                
                }}
              >
                {option.label}
        
              </button>
            );
          })}

            <button
                className={(foundIndex<0)?"selected":""}
           
               
                onClick={() => {
          
                  let newShadow = " "+currentShadow.trim();// add white space to make sure that the shadow doesn't match non custom options
                  props.updateFunc(props.definition.attribute, newShadow, props.definition.targetType); 
                  setSelectedIndex(-1);
                  
                  
                
                }}
              >
                <GearIcon/>
        
              </button>
        </div>
      </div>

    {selectedIndex<0 &&
        <div className="wb-input-group" style={{margin:"-12px 0 0 0",padding:"0"}} > 
            <div className="wb-input-row">
 
                <NumInput key={updateToggle.toString()} defaultVal= {x.current} label="X Offset" onUpdate={(val:number)=>{x.current=val; updateCustom();}}/>
                <NumInput key={updateToggle.toString()+"a"}defaultVal = {y.current} label="Y Offset" onUpdate={(val:number)=>{y.current = val; updateCustom();}}/>
            </div>
            <div className="wb-input-row">
                <NumInput fullWidth={!includeSpread} key={updateToggle.toString()+"b"}defaultVal = {blur.current} label="Blur" onUpdate={(val:number)=>{blur.current = val; updateCustom();}}/>
                {includeSpread&&<NumInput key={updateToggle.toString()+"c"}defaultVal = {spread.current} label="Spread" onUpdate={(val:number)=>{spread.current= val; updateCustom();}}/>}
            </div>
        <div style={{marginTop:"-12px",padding:"0 8px"}}>
            <ColorInputField key={updateToggle.toString()+"d"} siteData={props.siteData} label={"Shadow Color"} definition={props.definition} screenSize={props.screenSize} layoutObject={collerCollectoin} updateFunc={updateColor} saveFunc={props.saveFunc}  />
            </div>
        </div>
    }
    </div>
    </>
        

}